export const TEST_ID = {
  ALERT_CONFIRM: 'alert_confirm',
  ALERT_CANCEL: 'alert_cancel',
  BUSINESS_NUMBER_CHECK_BUTTON: 'business_number_check_button',
  PARTNER_MASTER_INVITE_CHECK_BUTTON: 'partner_master_invite_check_button',
  SVC_NAME_CHECK_BUTTON: 'svc_name_check_button'
} as const;
